import { BreadcrumbItem } from '@mitsubishi/shared/ui';

import { StateToken } from '@ngxs/store';

export const PROJECT_BREADCRUMBS_STATE_TOKEN = new StateToken<BreadcrumbItem[]>('breadcrumbs');
